import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "../../axiosInstance";
import { signUpApiEndpoints } from "../../../api";

// Saves the address the user confirmed after driving-licence OCR. A successful
// save is what marks the account verified, so this is the last gate before the
// user reaches the dashboard.

const initialState = {
  addressDetails: {
    flatNumber: "",
    buildingNumber: "",
    roadNumber: "",
    blockNumber: "",
    area: "",
  },
  data: null,
  isLoading: false,
  error: null,
};

export const verifyAddress = createAsyncThunk(
  "verifyAddress",
  (payload, { rejectWithValue }) => {
    return Axios.post(`${signUpApiEndpoints?.verifyAddress}`, payload)
      .then((res) => res.data)
      .catch((error) => {
        return rejectWithValue(error.response?.data || "Something went wrong");
      });
  }
);

const addressVerificationSlice = createSlice({
  name: "addressVerification",
  initialState,
  reducers: {
    setAddressDetails: (state, action) => {
      state.addressDetails = { ...state.addressDetails, ...action.payload };
    },
    resetAddressDetails: (state) => {
      state.addressDetails = initialState.addressDetails;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyAddress.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(verifyAddress.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(verifyAddress.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { setAddressDetails, resetAddressDetails } =
  addressVerificationSlice.actions;

export const selectAddressDetails = (state) =>
  state?.addressVerification?.addressDetails;
export const selectVerifyAddressLoading = (state) =>
  state?.addressVerification?.isLoading;
export const selectVerifyAddressError = (state) =>
  state?.addressVerification?.error;

export default addressVerificationSlice.reducer;
